// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/index.css */

/* keep your footer layout */
body {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
main {
  flex: 1 1;
}
footer {
  flex-shrink: 0;
}

/* safety: avoid random horizontal overflow */
html,
body,
#root {
  width: 100%;
  overflow-x: hidden;
}
* {
  box-sizing: border-box;
  min-width: 0;
}

/* IMPORTANT: overlay must NOT affect desktop */
.oc-overlay {
  display: none;
}

.oc-menu-btn {display:none;}
/* ============ MOBILE OFF-CANVAS SIDEBAR (ONLY) ============ */
@media (max-width: 768px) {

.oc-menu-btn {display:block;}
  /* Layout becomes single column on mobile */
  .oc-shell {
    grid-template-columns: 1fr !important;
    position: relative;
    min-width: 0;
  }

  /* Sidebar -> off-canvas (hidden by default) */
  .oc-sidebar {
    position: fixed !important;
    top: 0;
    left: 0;
    bottom: 0;

    width: 82vw;
    max-width: 320px;

    z-index: 1000;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;

    transform: translateX(-100%);
    transition: transform 0.22s ease;
  }

  /* Show sidebar when .is-sidebar-open is on .oc-shell */
  .oc-shell.is-sidebar-open .oc-sidebar {
    transform: translateX(0);
  }

  /* Overlay (only on mobile) */
  .oc-overlay {
    display: block;
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    z-index: 999;

    opacity: 0;
    pointer-events: none;
    transition: opacity 0.22s ease;
  }
  .oc-shell.is-sidebar-open .oc-overlay {
    opacity: 1;
    pointer-events: auto;
  }

  /* Make sure main/content stays full width */
  .oc-main {
    width: 100%;
    min-width: 0;
  }
  .oc-content {
    width: 100%;
    min-width: 0;
    padding: 12px;
  }

  /* Make sidebar items fit nicely */
  .oc-nav ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }
  .oc-nav li {
    display: block;
  }
  .oc-nav a,
  .oc-nav button {
    width: 100%;
    justify-content: flex-start;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* Order action buttons row should scroll horizontally */
  .order-summary-row {
    flex-direction: column;
    align-items: stretch;
  }
  .order-actions {
    width: 100%;
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 6px;
    gap: 8px;
  }
  .order-actions > * {
    flex: 0 0 auto;
  }
  .order-actions .btn {
    white-space: nowrap;
  }

  /* Filters and 2-col sections */
  .oc-f-grid {
    grid-template-columns: 1fr;
  }
  .split-2 {
    grid-template-columns: 1fr;
  }

  /* Tables: allow scroll */
  .oc-table-wrap {
    overflow-x: auto;
    max-width: 100%;
  }
  .oc-table {
    min-width: 0;
  }

  /* Modals and forms */
  .oc-modal {
    width: 95%;
  }
  .form-row {
    grid-template-columns: 1fr;
  }
}


@media (max-width: 900px) {

  /* Force the table + filter into a single column */
  .oc-card[style*="grid-template-columns"]{
    grid-template-columns: 1fr !important;
  }

  /* Allow children to shrink instead of overflowing */
  .oc-card[style*="grid-template-columns"] > *{
    min-width: 0;
  }

  /* Ensure filter inputs stretch full width */
  .oc-field,
  .oc-input,
  .oc-select{
    width: 100%;
  }

  /* Buttons stack nicely */
  .oc-actions{
    flex-direction: row;
    gap: 8px;
  }

  .oc-actions .oc-btn{
    flex: 1 1;
  }

  /* Prevent table from covering the filter */
  .oc-table-wrap{
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}


@media (max-width: 768px) {
  /* the card becomes the scroll container */
  .oc-card {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  /* keep table as a real table, but allow it to be wider than the screen */
  .oc-card > .oc-table {
    width: max-content;      /* key: table can exceed viewport */
    min-width: 100%;         /* at least fill the card */
    table-layout: auto;      /* don't force fixed layout */
    white-space: nowrap;     /* columns stay in one line -> horizontal scroll */
  }

  /* make sure nothing is being clipped */
  .oc-card > .oc-table th,
  .oc-card > .oc-table td {
    overflow: visible !important;
    text-overflow: clip !important;
  }

  /* Geographic is huge: allow wrapping inside that cell (optional) */
  .oc-card > .oc-table td:nth-child(6) {
    white-space: normal;     /* wrap long coords */
    word-break: break-word;  /* prevent layout blow-up */
    max-width: 260px;        /* adjust if you want */
  }

  /* action buttons can wrap */
  .oc-card > .oc-table td:last-child > div {
    flex-wrap: wrap;
  }
}





/* Removed mobile card view for tables */



@media (max-width: 768px) {
  /* the exact grid wrapper you pasted */
  div[style*="display: grid"][style*="grid-template-columns: 1fr 260px"],
  div[style*="display: grid"][style*="grid-template-columns: 1fr 320px"],
  div[style*="display: grid"][style*="grid-template-columns: 3fr 1fr"] {
    grid-template-columns: 1fr !important;
  }

  /* ensure both children can shrink and never overflow */
  div[style*="display: grid"][style*="grid-template-columns: 1fr 260px"] > *,
  div[style*="display: grid"][style*="grid-template-columns: 1fr 320px"] > *,
  div[style*="display: grid"][style*="grid-template-columns: 3fr 1fr"] > * {
    min-width: 0;
    width: 100%;
  }

  /* table should scroll horizontally instead of forcing overlap */
  div[style*="display: grid"][style*="grid-template-columns: 1fr 260px"] > div:first-child,
  div[style*="display: grid"][style*="grid-template-columns: 1fr 320px"] > div:first-child,
  div[style*="display: grid"][style*="grid-template-columns: 3fr 1fr"] > div:first-child {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  /* keep table layout stable on small screens */
  .oc-table{
    width: 100%;
    min-width: 800px; /* adjust if needed */
  }
}


/* Custom 4-column filter grid replaced by flex layout */
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,kBAAkB;;AAElB,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,SAAO;AACT;AACA;EACE,cAAc;AAChB;;AAEA,6CAA6C;AAC7C;;;EAGE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA,+CAA+C;AAC/C;EACE,aAAa;AACf;;AAEA,cAAc,YAAY,CAAC;AAC3B,+DAA+D;AAC/D;;AAEA,cAAc,aAAa,CAAC;EAC1B,2CAA2C;EAC3C;IACE,qCAAqC;IACrC,kBAAkB;IAClB,YAAY;EACd;;EAEA,8CAA8C;EAC9C;IACE,0BAA0B;IAC1B,MAAM;IACN,OAAO;IACP,SAAS;;IAET,WAAW;IACX,gBAAgB;;IAEhB,aAAa;IACb,gBAAgB;IAChB,iCAAiC;;IAEjC,4BAA4B;IAC5B,gCAAgC;EAClC;;EAEA,uDAAuD;EACvD;IACE,wBAAwB;EAC1B;;EAEA,6BAA6B;EAC7B;IACE,cAAc;IACd,eAAe;IACf,QAAQ;IACR,+BAA+B;IAC/B,YAAY;;IAEZ,UAAU;IACV,oBAAoB;IACpB,8BAA8B;EAChC;EACA;IACE,UAAU;IACV,oBAAoB;EACtB;;EAEA,4CAA4C;EAC5C;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;EACf;;EAEA,kCAAkC;EAClC;IACE,SAAS;IACT,UAAU;IACV,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;;IAEE,WAAW;IACX,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA,wDAAwD;EACxD;IACE,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;IACjC,mBAAmB;IACnB,QAAQ;EACV;EACA;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;;EAEA,+BAA+B;EAC/B;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;;EAEA,yBAAyB;EACzB;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,YAAY;EACd;;EAEA,qBAAqB;EACrB;IACE,UAAU;EACZ;EACA;IACE,0BAA0B;EAC5B;AACF;;;AAGA;;EAEE,kDAAkD;EAClD;IACE,qCAAqC;EACvC;;EAEA,oDAAoD;EACpD;IACE,YAAY;EACd;;EAEA,4CAA4C;EAC5C;;;IAGE,WAAW;EACb;;EAEA,yBAAyB;EACzB;IACE,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,SAAO;EACT;;EAEA,2CAA2C;EAC3C;IACE,gBAAgB;IAChB,iCAAiC;EACnC;AACF;;;AAGA;EACE,0CAA0C;EAC1C;IACE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA,yEAAyE;EACzE;IACE,kBAAkB,OAAO,mCAAmC;IAC5D,eAAe,UAAU,2BAA2B;IACpD,kBAAkB,OAAO,6BAA6B;IACtD,mBAAmB,MAAM,kDAAkD;EAC7E;;EAEA,uCAAuC;EACvC;;IAEE,4BAA4B;IAC5B,8BAA8B;EAChC;;EAEA,mEAAmE;EACnE;IACE,mBAAmB,MAAM,qBAAqB;IAC9C,sBAAsB,GAAG,2BAA2B;IACpD,gBAAgB,SAAS,uBAAuB;EAClD;;EAEA,4BAA4B;EAC5B;IACE,eAAe;EACjB;AACF;;;;;;AAMA,wCAAwC;;;;AAIxC;EACE,sCAAsC;EACtC;;;IAGE,qCAAqC;EACvC;;EAEA,uDAAuD;EACvD;;;IAGE,YAAY;IACZ,WAAW;EACb;;EAEA,gEAAgE;EAChE;;;IAGE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA,8CAA8C;EAC9C;IACE,WAAW;IACX,gBAAgB,EAAE,qBAAqB;EACzC;AACF;;;AAGA,wDAAwD","sourcesContent":["/* src/index.css */\n\n/* keep your footer layout */\nbody {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\nmain {\n  flex: 1;\n}\nfooter {\n  flex-shrink: 0;\n}\n\n/* safety: avoid random horizontal overflow */\nhtml,\nbody,\n#root {\n  width: 100%;\n  overflow-x: hidden;\n}\n* {\n  box-sizing: border-box;\n  min-width: 0;\n}\n\n/* IMPORTANT: overlay must NOT affect desktop */\n.oc-overlay {\n  display: none;\n}\n\n.oc-menu-btn {display:none;}\n/* ============ MOBILE OFF-CANVAS SIDEBAR (ONLY) ============ */\n@media (max-width: 768px) {\n\n.oc-menu-btn {display:block;}\n  /* Layout becomes single column on mobile */\n  .oc-shell {\n    grid-template-columns: 1fr !important;\n    position: relative;\n    min-width: 0;\n  }\n\n  /* Sidebar -> off-canvas (hidden by default) */\n  .oc-sidebar {\n    position: fixed !important;\n    top: 0;\n    left: 0;\n    bottom: 0;\n\n    width: 82vw;\n    max-width: 320px;\n\n    z-index: 1000;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n\n    transform: translateX(-100%);\n    transition: transform 0.22s ease;\n  }\n\n  /* Show sidebar when .is-sidebar-open is on .oc-shell */\n  .oc-shell.is-sidebar-open .oc-sidebar {\n    transform: translateX(0);\n  }\n\n  /* Overlay (only on mobile) */\n  .oc-overlay {\n    display: block;\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.45);\n    z-index: 999;\n\n    opacity: 0;\n    pointer-events: none;\n    transition: opacity 0.22s ease;\n  }\n  .oc-shell.is-sidebar-open .oc-overlay {\n    opacity: 1;\n    pointer-events: auto;\n  }\n\n  /* Make sure main/content stays full width */\n  .oc-main {\n    width: 100%;\n    min-width: 0;\n  }\n  .oc-content {\n    width: 100%;\n    min-width: 0;\n    padding: 12px;\n  }\n\n  /* Make sidebar items fit nicely */\n  .oc-nav ul {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n  }\n  .oc-nav li {\n    display: block;\n  }\n  .oc-nav a,\n  .oc-nav button {\n    width: 100%;\n    justify-content: flex-start;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  /* Order action buttons row should scroll horizontally */\n  .order-summary-row {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  .order-actions {\n    width: 100%;\n    flex-wrap: nowrap;\n    overflow-x: auto;\n    overflow-y: hidden;\n    -webkit-overflow-scrolling: touch;\n    padding-bottom: 6px;\n    gap: 8px;\n  }\n  .order-actions > * {\n    flex: 0 0 auto;\n  }\n  .order-actions .btn {\n    white-space: nowrap;\n  }\n\n  /* Filters and 2-col sections */\n  .oc-f-grid {\n    grid-template-columns: 1fr;\n  }\n  .split-2 {\n    grid-template-columns: 1fr;\n  }\n\n  /* Tables: allow scroll */\n  .oc-table-wrap {\n    overflow-x: auto;\n    max-width: 100%;\n  }\n  .oc-table {\n    min-width: 0;\n  }\n\n  /* Modals and forms */\n  .oc-modal {\n    width: 95%;\n  }\n  .form-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n\n@media (max-width: 900px) {\n\n  /* Force the table + filter into a single column */\n  .oc-card[style*=\"grid-template-columns\"]{\n    grid-template-columns: 1fr !important;\n  }\n\n  /* Allow children to shrink instead of overflowing */\n  .oc-card[style*=\"grid-template-columns\"] > *{\n    min-width: 0;\n  }\n\n  /* Ensure filter inputs stretch full width */\n  .oc-field,\n  .oc-input,\n  .oc-select{\n    width: 100%;\n  }\n\n  /* Buttons stack nicely */\n  .oc-actions{\n    flex-direction: row;\n    gap: 8px;\n  }\n\n  .oc-actions .oc-btn{\n    flex: 1;\n  }\n\n  /* Prevent table from covering the filter */\n  .oc-table-wrap{\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n\n\n@media (max-width: 768px) {\n  /* the card becomes the scroll container */\n  .oc-card {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  /* keep table as a real table, but allow it to be wider than the screen */\n  .oc-card > .oc-table {\n    width: max-content;      /* key: table can exceed viewport */\n    min-width: 100%;         /* at least fill the card */\n    table-layout: auto;      /* don't force fixed layout */\n    white-space: nowrap;     /* columns stay in one line -> horizontal scroll */\n  }\n\n  /* make sure nothing is being clipped */\n  .oc-card > .oc-table th,\n  .oc-card > .oc-table td {\n    overflow: visible !important;\n    text-overflow: clip !important;\n  }\n\n  /* Geographic is huge: allow wrapping inside that cell (optional) */\n  .oc-card > .oc-table td:nth-child(6) {\n    white-space: normal;     /* wrap long coords */\n    word-break: break-word;  /* prevent layout blow-up */\n    max-width: 260px;        /* adjust if you want */\n  }\n\n  /* action buttons can wrap */\n  .oc-card > .oc-table td:last-child > div {\n    flex-wrap: wrap;\n  }\n}\n\n\n\n\n\n/* Removed mobile card view for tables */\n\n\n\n@media (max-width: 768px) {\n  /* the exact grid wrapper you pasted */\n  div[style*=\"display: grid\"][style*=\"grid-template-columns: 1fr 260px\"],\n  div[style*=\"display: grid\"][style*=\"grid-template-columns: 1fr 320px\"],\n  div[style*=\"display: grid\"][style*=\"grid-template-columns: 3fr 1fr\"] {\n    grid-template-columns: 1fr !important;\n  }\n\n  /* ensure both children can shrink and never overflow */\n  div[style*=\"display: grid\"][style*=\"grid-template-columns: 1fr 260px\"] > *,\n  div[style*=\"display: grid\"][style*=\"grid-template-columns: 1fr 320px\"] > *,\n  div[style*=\"display: grid\"][style*=\"grid-template-columns: 3fr 1fr\"] > * {\n    min-width: 0;\n    width: 100%;\n  }\n\n  /* table should scroll horizontally instead of forcing overlap */\n  div[style*=\"display: grid\"][style*=\"grid-template-columns: 1fr 260px\"] > div:first-child,\n  div[style*=\"display: grid\"][style*=\"grid-template-columns: 1fr 320px\"] > div:first-child,\n  div[style*=\"display: grid\"][style*=\"grid-template-columns: 3fr 1fr\"] > div:first-child {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  /* keep table layout stable on small screens */\n  .oc-table{\n    width: 100%;\n    min-width: 800px; /* adjust if needed */\n  }\n}\n\n\n/* Custom 4-column filter grid replaced by flex layout */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
